import { css } from '@emotion/react';
import { type FC } from 'react';
import { LogoComponent } from '~/_shared/components/logo/logo.component';
import {
  getLogoTagLine, type LogoVersion,
} from '~/_shared/components/logo/logo.helpers';
import {
  ScrollBarComponent, ScrollbarType,
} from '~/_shared/components/scrollbar/scrollbar.component';
import type { Theme } from '~/_shared/themes/theme.model';

const wrapperStyle = (maxWidth: number) => css({
  maxWidth,
  padding: '0 10px 20px',
  margin: '0 auto',
});

const logoWrapperStyle = css({
  display: 'flex',
  flexDirection: 'column',
  margin: '64px 0 32px',
  alignItems: 'center',
});

const taglineStyle = (theme: Theme) => css({
  fontSize: 12,
  color: theme.textColors.secondary,
});

type AuthorizationPageWrapperProps = Readonly<{
  children?: React.ReactNode;
  logoVersion?: LogoVersion;
  maxWidth?: number;
}>;

export const AuthorizationPageWrapperComponent: FC<AuthorizationPageWrapperProps> = (props) => {
  const maxWidth = props.maxWidth ?? 600;
  const tagLine = getLogoTagLine(props.logoVersion);

  return (
    <ScrollBarComponent
      type={ScrollbarType.Vertical}
    >
      <div css={wrapperStyle(maxWidth)}>
        <div css={logoWrapperStyle} >
          <LogoComponent width="210px" logoVersion={props.logoVersion} />
          {tagLine && (
            <div css={taglineStyle}>
              {tagLine}
            </div>
          )}
        </div>
        {props.children}
      </div>
    </ScrollBarComponent>
  );
};
